import { Directive, HostListener, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { DEVICE_SIZE } from '../../models/others.model';
import { ToolsService } from '../../services/tools.service';
import { mediaConfig } from '../../../spartacus/features/store-front/default-media.config';

@Directive({
  selector: '[smallerThan]',
  standalone: false,
})
export class SmallerThanDirective implements OnInit {
  private hasView = false;
  deviceSize!: DEVICE_SIZE;

  @Input() set smallerThan(deviceSize: DEVICE_SIZE) {
    this.deviceSize = deviceSize;
  }

  constructor(
    private toolsService: ToolsService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.testElement();
  }

  @HostListener('window:resize') testElement() {
    const sizeScreen = this.toolsService.getSizeScreen().width;
    const biggestSize = mediaConfig!.mediaFormats![this.deviceSize.toLocaleLowerCase()]!.width!;
    const showComponente = sizeScreen < biggestSize;

    if (showComponente && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!showComponente && this.hasView) {
      this.viewContainer.remove();
      this.hasView = false;
    }
  }
}
